import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import RoomsPreview from './components/RoomsPreview';
import DiningSection from './components/DiningSection';
import EventsPreview from './components/EventsPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "The Ocean View Inn & Sports Pub",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/menu?search={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "name": "The Ocean View Inn & Sports Pub",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "image": "https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "84500 Overseas Hwy",
        "addressLocality": "Islamorada",
        "addressRegion": "FL",
        "postalCode": "33036",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.9470979,
        "longitude": -80.6019239
      },
      "telephone": "(305) 664-8052",
      "email": "resinfo@theocean-view.com",
      "sameAs": [
        "https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394",
        "https://www.instagram.com/oceanview_inn_pub/"
      ],
      "servesCuisine": ["American", "Seafood"],
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "11:00",
          "closes": "22:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Friday", "Saturday"],
          "opens": "11:00",
          "closes": "01:00"
        }
      ],
      "hasMenu": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/menu`,
      "acceptsReservations": true,
      "amenityFeature": [
        {
          "@type": "LocationFeatureSpecification",
          "name": "Boat Dock Access",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Waterfront Dining",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Free Parking",
          "value": true
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "BarOrPub",
      "name": "The Ocean View Sports Pub",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/pub`,
      "image": "https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "84500 Overseas Hwy",
        "addressLocality": "Islamorada",
        "addressRegion": "FL",
        "postalCode": "33036",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.9470979,
        "longitude": -80.6019239
      },
      "telephone": "(305) 664-8052",
      "email": "resinfo@theocean-view.com",
      "sameAs": [
        "https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394",
        "https://www.instagram.com/oceanview_inn_pub/"
      ],
      "servesCuisine": ["American", "Seafood", "Bar Food"],
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "11:00",
          "closes": "22:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Friday", "Saturday"],
          "opens": "11:00",
          "closes": "01:00"
        }
      ],
      "hasMenu": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/menu`,
      "acceptsReservations": true
    },
    {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      "name": "The Ocean View Inn",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/rooms`,
      "image": "https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "84500 Overseas Hwy",
        "addressLocality": "Islamorada",
        "addressRegion": "FL",
        "postalCode": "33036",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.9470979,
        "longitude": -80.6019239
      },
      "telephone": "(305) 664-8052",
      "email": "resinfo@theocean-view.com",
      "sameAs": [
        "https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394",
        "https://www.instagram.com/oceanview_inn_pub/"
      ],
      "priceRange": "$$",
      "amenityFeature": [
        {
          "@type": "LocationFeatureSpecification",
          "name": "Free WiFi",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Free Parking",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Swimming Pool",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Boat Dock",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "On-site Restaurant",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "On-site Bar",
          "value": true
        }
      ],
      "checkinTime": "15:00",
      "checkoutTime": "11:00"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Islamorada Hotel, Bar & Restaurant | The Ocean View Inn & Sports Pub with Boat Dock"
        description="The Ocean View Inn is Islamorada's premier waterfront hotel, bar, and restaurant with boat dock access. Our oceanfront inn features comfortable motel-style rooms, a popular sports pub serving fresh seafood and American cuisine, full bar with craft cocktails, and direct water access for boaters. Located on the Overseas Highway in the heart of the Florida Keys. Book your stay at our Islamorada hotel today!"
        keywords="Islamorada hotel, hotel in Islamorada, Islamorada inn, motel Islamorada, bar in Islamorada, pub in Islamorada, restaurant in Islamorada, Islamorada waterfront hotel, boat dock Islamorada, Florida Keys hotel, Islamorada lodging"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        ogTitle="Islamorada Hotel, Bar & Restaurant | The Ocean View Inn with Boat Dock"
        ogDescription="Waterfront hotel, sports pub, and restaurant in Islamorada with boat dock access. Enjoy oceanfront lodging, great food, cold drinks, and direct water access in the Florida Keys."
        ogImage="https://theocean-view.com/wp-content/uploads/2023/10/qtq80-M8xK7L.jpeg"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        structuredData={structuredData}
        geoPosition="24.9470979;-80.6019239"
        geoRegion="US-FL"
        geoPlacename="Islamorada, Florida"
      />
      <Header />
      <main>
        <h1 className="sr-only">The Ocean View Inn - Islamorada Hotel, Bar, Restaurant & Boat Dock</h1>
        <HeroSection />
        <FeaturesSection />
        <RoomsPreview />
        <DiningSection />
        <EventsPreview />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
